import { Input } from 'antd';
import styled from 'styled-components';
import { SquadPicker as SquadPickerAtom } from '../squad-picker';

const { TextArea } = Input;

export const SquadPicker = styled(SquadPickerAtom)`
  padding: 0;
`;

export const PopupContent = styled.div`
  --rte-content-padding: var(--spacing-06) 0;

  padding: var(--spacing-05) var(--spacing-04);
  width: 272px;
`;

export const TaskTitle = styled(TextArea)`
  &&,
  &&:focus,
  &&:active {
    border: none;
    border-radius: 0;
    outline: none;
    box-shadow: none;
    font-size: var(--heading-5-size);
    margin-bottom: var(--spacing-05);
    resize: none;
  }

  &&:focus,
  &&:active {
    border-bottom: solid 1px var(--primary-color);
  }
`;

export const NegativeMarginWrapper = styled.div`
  margin-left: calc(-1 * var(--spacing-05));
  margin-right: calc(-1 * var(--spacing-05));
  svg {
    margin-right: var(--spacing-03);
  }
`;

export const TaskActions = styled.div`
  display: flex;
  justify-content: flex-start;

  > :last-child {
    margin-left: var(--spacing-04);
  }
`;
